import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

import {
  blue_star,
  Dashboard_active,
  Dashboard_de,
  Login_title,
  Regional_active,
  Regional_de,
  Roles_active,
  Roles_de,
  service_active,
  service_deactive,
  unblue_star,
} from "../assets/img";
import LogoutIcon from "@mui/icons-material/Logout";
import FlutterDashIcon from "@mui/icons-material/FlutterDash";
import { get, post } from "../Screen/redux/api/ApiHandler";
import { URLS } from "../Screen/redux/api/Constants";
import toast from "react-hot-toast";

const ProfileNavBar = ({ setSaidList }) => {
  const [saideBarShow, setSaidBarShow] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [popup, setPopup] = useState(false);
  const [count, setCount] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const toggleSidebar = () => {
    setSaidBarShow(!saideBarShow);
    setActiveMenu(null);
  };

  const handleMenuClick = (menuKey, defaultRoute) => {
    setSaidBarShow(true);
    setActiveMenu((prev) => (prev === menuKey ? null : menuKey));
    if (activeMenu !== menuKey && defaultRoute) {
      navigate(defaultRoute);
    }
  };

  const handleLogout = async () => {
    let res = await get(URLS.LOGOUT);
    console.log("logoutRes", res);
    if (res?.status == "success") {
      toast.success(res?.message);
      localStorage.clear();
      setPopup(false);
      navigate("/");
    }
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const fetchNotification = async () => {
    let payload = {
      page: 1,
      search: "",
      rows: 10,
      order: "desc",
      from_date: "",
      to_date: "",
      title: "",
    };
    let res = await post(URLS.NOTICATION, payload);
    console.log("conutRes", res);
    if (res?.status == "success") {
      setCount(res?.pagination?.total);
    }
  };

  // Scroll to bottom when menu opens
  useEffect(() => {
    if (menuOpen && menuRef.current) {
      const el = menuRef.current;
      el.scrollTo({
        top: el.scrollHeight,
        behavior: "smooth",
      });
    }

    fetchNotification();
  }, [menuOpen, navigate]);

  return (
    <div className={`${saideBarShow ? "sidebar" : "close_sidebar"}`}>
      <header>
        <div className="image_text pointer d-flex ac-jc p-2 mt-2 Header_title">
          {saideBarShow ? (
            // When sidebar is expanded — show logo
            <img src={Login_title} className="Login_title1" alt="logo" />
          ) : (
            // When sidebar is minimized — show FlutterDashIcon
            <FlutterDashIcon
              className="FlutterDashIcon"
              style={{ fontSize: 40 }}
            />
          )}
        </div>
      </header>

      <div onClick={toggleSidebar}>
        {saideBarShow ? (
          <KeyboardDoubleArrowLeftIcon className="arrow-right" />
        ) : (
          <KeyboardDoubleArrowRightIcon className="arrow-left" />
        )}
      </div>

      <div ref={menuRef} className="menu_bar overflow-x-hidden overflow-scroll">
        <div className="menu">
          <ul className="menu_links ps-0">
            <li
              className="nav_link trans"
              onClick={() => handleMenuClick("dashboard", "/dashboard")}
            >
              <h4
                className={`ps-3 ${
                  ["dashboard"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["dashboard"].includes(splitLocation[1])
                      ? Dashboard_active
                      : Dashboard_de
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Dashboard
                </span>
              </h4>
            </li>
            {/* <li
              className="nav_link trans"
              onClick={() => handleMenuClick("roles", "/roles")}
            >
              <h4
                className={`ps-3 ${["roles"].includes(splitLocation[1]) ? "f3 active_bar" : ""
                  }`}
              >
                <img
                  src={
                    ["roles"].includes(splitLocation[1])
                      ? Roles_active
                      : Roles_de
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Roles
                </span>
              </h4>
            </li> */}
            {/* User List */}
            <li
              className="nav_link trans"
              onClick={() => handleMenuClick("HO", "/super-admin")}
            >
              <h4
                className={`ps-3 ${
                  [
                    "super-admin",
                    "super-admin-add",
                    "inventory",
                    "inventory-add",
                    "technical",
                    "technical-add",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : "super-admin"
                }`}
              >
                <img
                  src={
                    [
                      "super-admin",
                      "super-admin-add",
                      "inventory",
                      "inventory-add",
                      "technical",
                      "technical-add",
                    ].includes(splitLocation[1])
                      ? Roles_active
                      : Roles_de
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  HO <KeyboardArrowDownOutlinedIcon />
                </span>
              </h4>
            </li>
            {activeMenu === "HO" && (
              <ul className="sub-menu show">
                <li
                  className="nav_link trans my-0"
                  onClick={() => navigate("/super-admin")}
                >
                  <h4
                    className={`${
                      ["super-admin", "super-admin-add"].includes(
                        splitLocation[1]
                      )
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Super Admin
                  </h4>
                </li>
                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/inventory")}
                >
                  <h4
                    className={`${
                      ["inventory", "inventory-add"].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Inventory
                  </h4>
                </li>

                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/technical")}
                >
                  <h4
                    className={`${
                      ["technical", "technical-add"].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Technical
                  </h4>
                </li>
              </ul>
            )}
            <li
              className="nav_link trans"
              onClick={() =>
                handleMenuClick("regional-manager", "/regional-manager")
              }
            >
              <h4
                className={`ps-3 ${
                  ["regional-manager", "regional-add"].includes(
                    splitLocation[1]
                  )
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["regional-manager", "regional-add"].includes(
                      splitLocation[1]
                    )
                      ? Regional_de
                      : Regional_active
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Regional Manager
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans"
              onClick={() =>
                handleMenuClick("service-engineer", "/service-engineer")
              }
            >
              <h4
                className={`ps-3 ${
                  ["service-engineer", "service-add"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["service-engineer", "service-add"].includes(
                      splitLocation[1]
                    )
                      ? service_active
                      : service_deactive
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Service Engineer
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans"
              onClick={() => handleMenuClick("customer", "/customer")}
            >
              <h4
                className={`ps-3 ${
                  ["customer", "customer-printers"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["customer", "customer-printers"].includes(splitLocation[1])
                      ? Roles_active
                      : Roles_de
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Customer
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans"
              onClick={() => handleMenuClick("master", "/region")}
            >
              <h4
                className={`ps-3 ${
                  [
                    "region",
                    "region-add",
                    "fault-type",
                    "fault-add",
                    "spare-type",
                    "spare-add",
                    "support",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : "region"
                }`}
              >
                <img
                  src={
                    [
                      "region",
                      "region-add",
                      "fault-type",
                      "fault-add",
                      "spare-type",
                      "spare-add",
                      "support",
                    ].includes(splitLocation[1])
                      ? Roles_active
                      : Roles_de
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Master <KeyboardArrowDownOutlinedIcon />
                </span>
              </h4>
            </li>
            {activeMenu === "master" && (
              <ul className="sub-menu show">
                <li
                  className="nav_link trans my-0"
                  onClick={() => navigate("/region")}
                >
                  <h4
                    className={`${
                      ["region", "region-add"].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Region
                  </h4>
                </li>
                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/fault-type")}
                >
                  <h4
                    className={`${
                      ["fault-type", "fault-add"].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Fault Type
                  </h4>
                </li>

                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/spare-type")}
                >
                  <h4
                    className={`${
                      ["spare-type", "spare-add"].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Spare Type
                  </h4>
                </li>
                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/support")}
                >
                  <h4
                    className={`${
                      ["support"].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Support
                  </h4>
                </li>
              </ul>
            )}
            <li
              className="nav_link trans"
              onClick={() => handleMenuClick("ticket", "/new-ticket")}
            >
              <h4
                className={`ps-3 ${
                  [
                    "ticket",
                    "new-ticket",
                    "new-ticket-view",
                    "pending-view",
                    "pending-move",
                    "pending",
                    "pending-table",
                    "pending-view",
                    "pending-move",
                    "inventory-table",
                    "inventory-view",
                    "inventory-move",
                    "technical-table",
                    "technical-view",
                    "technical-move",
                    "next-visit",
                    "next-visit-view",
                    "next-move",
                    "service-table",
                    "service-view",
                    "service-move",
                    "Work-closed",
                    "work-view",
                    "Work-move",
                    "closed-table",
                    "closed-view",
                    "closed-move",
                    "service-table",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : "region"
                }`}
              >
                <img
                  src={
                    [
                      "ticket",
                      "new-ticket",
                      "new-ticket-view",
                      "pending-view",
                      "pending-move",
                      "pending",
                      "pending-table",
                      "pending-view",
                      "pending-move",
                      "inventory-table",
                      "inventory-view",
                      "inventory-move",
                      "technical-table",
                      "technical-view",
                      "technical-move",
                      "next-visit",
                      "next-visit-view",
                      "next-move",
                      "service-table",
                      "service-view",
                      "service-move",
                      "Work-closed",
                      "work-view",
                      "Work-move",
                      "closed-table",
                      "closed-view",
                      "closed-move",
                      "service-table",
                    ].includes(splitLocation[1])
                      ? Roles_active
                      : Roles_de
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Ticket <KeyboardArrowDownOutlinedIcon />
                </span>
              </h4>
            </li>
            {activeMenu === "ticket" && (
              <ul className="sub-menu show">
                <li
                  className="nav_link trans my-0"
                  onClick={() => navigate("/new-ticket")}
                >
                  <h4
                    className={`${
                      ["new-ticket", "new-ticket-view"].includes(
                        splitLocation[1]
                      )
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    New Ticket
                  </h4>
                </li>
                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/pending")}
                >
                  <h4
                    className={`${
                      [
                        "pending",
                        "pending-table",
                        "pending-view",
                        "pending-move",
                        "inventory-table",
                        "inventory-view",
                        "inventory-move",
                        "technical-table",
                        "technical-view",
                        "technical-move",
                        "next-visit",
                        "next-visit-view",
                        "next-move",
                        "service-table",
                      ].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Pending Ticket
                  </h4>
                </li>

                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/Work-closed")}
                >
                  <h4
                    className={`${
                      ["Work-closed", "work-view", "work-move"].includes(
                        splitLocation[1]
                      )
                        ? "f3 sub_active"
                        : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Work Completed
                  </h4>
                </li>
                <li
                  className="nav_link trans my-1"
                  onClick={() => navigate("/closed-table")}
                >
                  <h4
                    className={`${
                      ["closed-table", "closed-view", "closed-move"].includes(
                        splitLocation[1]
                      )
                        ? "f3 sub_active"
                        : ""
                    } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                  >
                    Closed Ticket
                  </h4>
                </li>
              </ul>
            )}
            <li className="nav_link trans" onClick={() => navigate("/report")}>
              <h4
                className={`ps-3 ${
                  ["report", "report-list"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["report", "report-list"].includes(splitLocation[1])
                      ? blue_star
                      : unblue_star
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  Report
                </span>
              </h4>
            </li>
            <li
              className="nav_link trans"
              onClick={() => navigate("/notification")}
            >
              <h4
                className={`ps-3 d-flex align-items-center ${
                  ["notification"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <div className="notification-wrapper">
                  <NotificationsActiveIcon className="icon" />
                  {count > 0 && (
                    <span className="notification-badge">
                      {count > 99 ? "99+" : count}
                    </span>
                  )}
                </div>

                <span className="text text-nowrap f3 ms-2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18">
                  Notification
                </span>
              </h4>
            </li>
          </ul>
        </div>
      </div>

      {/* Logout Button */}
      <div
        style={{ cursor: "pointer" }}
        className="d-flex ac-jb py-3 px-2 bg-primary2"
        onClick={() => setPopup(true)}
      >
        <h4 className="f4 fs-md-13 fs-xl-16 mb-0 ms-4">Logout</h4>
        <LogoutIcon />
      </div>

      {/* Logout Confirmation Popup */}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 mt-4 mb-2 f2 fs-xs-14 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 ">
              Are you sure you want to <LogoutIcon /> logout?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => setPopup(false)}
                className="no-btn f2 w-40"
              >
                No
              </button>
              <button onClick={handleLogout} className="yes-btn f2 w-40">
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileNavBar;
